import {
  IActionParameter,
  IAiActionInfo,
  ICrewAgentDTO,
  IOpenAIUserInterfaceValidationAnalysisError
} from "@kuika/kuika-cl-model";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface AiActionProviderState {
  getStringifiedAiActionInfo: (stringifiedAiActionInfo) => IAiActionInfo | null;
  getStringifiedAiAgentInfo: (stringifiedAiAgentInfo) => ICrewAgentDTO | null;
  projectAuditErrors: IOpenAIUserInterfaceValidationAnalysisError[];
  setprojectAuditErrors: (errors: IOpenAIUserInterfaceValidationAnalysisError[]) => void;
  activeAIActionInfoForRightPanel?: IAiActionInfo;
  setAIActionDataForRightPanel: (aiActionInfo?: IAiActionInfo, aiActionParams?: IActionParameter[]) => void;
}

export class AiActionProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  AiActionProviderState
> {
  static defaultState: AiActionProviderState = {
    getStringifiedAiActionInfo: () => null,
    getStringifiedAiAgentInfo: () => null,
    projectAuditErrors: [],
    setprojectAuditErrors: () => {},
    activeAIActionInfoForRightPanel: undefined,
    setAIActionDataForRightPanel: () => {}
  };

  getProviderValues = (): AiActionProviderState => {
    return {
      getStringifiedAiActionInfo: this.getStringifiedAiActionInfo,
      getStringifiedAiAgentInfo: this.getStringifiedAiAgentInfo,
      projectAuditErrors: this.state.projectAuditErrors,
      setprojectAuditErrors: this.setProjectAuditErrors,
      activeAIActionInfoForRightPanel: this.state.activeAIActionInfoForRightPanel,
      setAIActionDataForRightPanel: this.setAIActionDataForRightPanel
    };
  };

  getStringifiedAiActionInfo = (stringifiedAiActionInfo) => {
    try {
      return JSON.parse(stringifiedAiActionInfo) as IAiActionInfo;
    } catch (e) {
      console.warn(e);
      return null;
    }
  };

  getStringifiedAiAgentInfo = (stringifiedAiAgentInfo) => {
    try {
      return JSON.parse(stringifiedAiAgentInfo) as ICrewAgentDTO;
    } catch (e) {
      console.warn(e);
      return null;
    }
  };

  setProjectAuditErrors = (errors: IOpenAIUserInterfaceValidationAnalysisError[] = []) => {
    this.setState({ projectAuditErrors: errors });
  };

  setAIActionDataForRightPanel = (
    activeAIActionInfoForRightPanel?: IAiActionInfo,
    actionParameters: IActionParameter[] = []
  ) => {
    this.setState({ activeAIActionInfoForRightPanel, actionParameters });
  };
}
